import { Checkbox } from 'antd';
import { useFormikContext } from 'formik';
import useSmartField from 'hooks/useSmartField';
import { useTranslate } from '@tolgee/react';
import { FV, GatherContainer } from './share';
import WaitReply from './WaitReply';

const returnRefundScenarios: Remind.ReturnRefundScenario[] = [
  'returnRefundItemMissing',
  'returnRefundWrongItem',
  'returnRefundPhysicalDmg',
  'returnRefundFunctionalDmg',
];

function ReturnRefundField() {
  const { t } = useTranslate();

  const scenarioLabelMap: Record<Remind.ReturnRefundScenario, string> = {
    returnRefundItemMissing: t('aide.收到货物少件'),
    returnRefundWrongItem: t('aide.收到货物错误'),
    returnRefundPhysicalDmg: t('aide.收到货物破损'),
    returnRefundFunctionalDmg: t('aide.收到货物无法使用'),
  };

  const {
    values: {
      orderAbandonGroup: { enable },
    },
  } = useFormikContext<FV>();

  const {
    field: { value, onChange },
  } = useSmartField<
    FV['orderAbandonGroup']['remindScene']['RETURN_REFUND_RETRIEVE']['returnRefundRetrieveConfig']
  >('orderAbandonGroup.remindScene.RETURN_REFUND_RETRIEVE.returnRefundRetrieveConfig');

  const disabled = !enable || returnRefundScenarios.every((scenario) => !value[scenario]);

  const { waitReply, closeCondition } = value;

  const { cancelled, acceptedOrRefundPaid, closed } = closeCondition;

  return (
    <GatherContainer>
      <h4>{t('newScene.RETURN_REFUND_RETRIEVE')}</h4>
      <div>
        <h5>
          {t('remind.选择x场景', {
            x: t('newScene.RETURN_REFUND_RETRIEVE'),
          })}
        </h5>
        {returnRefundScenarios.map((scenario) => {
          const { [scenario]: checked } = value;

          const { [scenario]: label } = scenarioLabelMap;

          return (
            <Checkbox
              key={scenario}
              disabled={!enable}
              checked={checked}
              onChange={({ target: { checked } }) => {
                onChange({
                  ...value,
                  [scenario]: checked,
                });
              }}
            >
              {label}
            </Checkbox>
          );
        })}
      </div>
      <WaitReply
        waitReply={waitReply}
        onWaitReplyChange={(waitReply) => onChange({ ...value, waitReply })}
        disabled={disabled}
      />
      <div>
        <h5>{t('remind.自动关闭当前会话的重要提醒')}</h5>
        <div>
          <Checkbox
            disabled={disabled}
            checked={cancelled}
            onChange={({ target: { checked } }) =>
              onChange({
                ...value,
                closeCondition: {
                  ...closeCondition,
                  cancelled: checked,
                },
              })
            }
          >
            {t('remind.买家撤回退货退款申请')}
          </Checkbox>
          <Checkbox
            disabled={disabled}
            checked={closed}
            onChange={({ target: { checked } }) =>
              onChange({
                ...value,
                closeCondition: {
                  ...closeCondition,
                  closed: checked,
                },
              })
            }
          >
            {t('remind.平台拒绝退货退款申请')}
          </Checkbox>
          <Checkbox
            disabled={disabled}
            checked={acceptedOrRefundPaid}
            onChange={({ target: { checked } }) =>
              onChange({
                ...value,
                closeCondition: {
                  ...closeCondition,
                  acceptedOrRefundPaid: checked,
                },
              })
            }
          >
            {t('remind.卖家同意退货退款申请')}
          </Checkbox>
        </div>
      </div>
    </GatherContainer>
  );
}

export default ReturnRefundField;
